<section class="customize-columns">
  <div class="quick-filter">
    <mat-form-field class="search-bar">
      <mat-icon matPrefix id="search-icon">search</mat-icon>
      <input
        id="adjust-hit-overview-quick-filter"
        matInput
        [(ngModel)]="searchText"
        placeholder="Search..."
        name="search"
        autocomplete="off"
      />
    </mat-form-field>
  </div>
  <div
    cdkDropList
    class="columns-container"
    [class.no-scroll]="filteredColumns.length === 0"
    [class.with-scroll]="filteredColumns.length > 0"
    [cdkDropListOrientation]="'vertical'"
    (cdkDropListDropped)="onColumnDrop($event)"
  >
    @if (filteredColumns.length > 0) { @for (column of filteredColumns; track
    column; let i = $index) {
    <div class="column-item" cdkDrag [cdkDragBoundary]="'.columns-container'">
      <mat-checkbox
        id="select-column"
        class="checkbox-control"
        color="primary"
        [checked]="column.checked"
        (change)="toggleColumn(column)"
      >
      </mat-checkbox>
      <mat-icon id="drag-column" class="drag-handle" cdkDragHandle
        >drag_handle</mat-icon
      >
      <span class="column-name">{{ column.fieldLabel }}</span>
    </div>
    } } @else {
    <span class="empty-state">No matches.</span>
    }
  </div>
</section>
